module.exports = __webpack_public_path__ + "media/images/lp_consultation/reviews-voice02-aafd77ff181a5d3a5f217d466ef36c41.jpg";